/**
 * Os achados do rastreador — hoje três linhas sobre o `PainelAchados` genérico.
 *
 * A tela ancora no APARELHO, mas o sujeito do achado é o veículo onde ele está instalado; por isso
 * a rota própria, que resolve a instalação vigente e delega ao mesmo motor. Tudo o que este arquivo
 * tinha de próprio — a frase, o ícone por tipo, a etiqueta do método, a separação entre afirmação e
 * palpite — virou registro: `lib/achados/frases.tsx` e `lib/achados/dominios.ts`.
 */
import { PainelAchados } from './PainelAchados';

export function PainelAchadosRastreador({ rastreadorId }: { rastreadorId: string }) {
  return (
    <PainelAchados dominio="rastreamento" url={`/cadastro/rastreadores/${rastreadorId}/achados`} />
  );
}
